import { useMutation } from 'react-query';

import { googleSignup } from '../../lib/api';

export function useMutateGoogleSignup() {
  return useMutation(googleSignup);
}
